"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var isUndefined = require('lodash/isUndefined');

var _require = require('boolean'),
    parseBoolean = _require["boolean"];

var moment = require('moment');
/**
 * OrderNote
 * @param {Date} params.timestamp
 * @param {Boolean} params.active
 * @param {String} params.user_id
 * @param {String} params.designation - one of 'order' | 'payment' | <print_job_designation> | <shipment_designation>
 * @param {String} params.text
 */


var OrderNote = function OrderNote() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  _classCallCheck(this, OrderNote);

  this.timestamp = params.timestamp || moment().toISOString();
  this.active = isUndefined(params.active) ? true : parseBoolean(params.active);
  this.user_id = params.user_id || null;
  this.designation = params.designation || 'order';
  this.text = params.text || ''; // getting rid of reprint notes altogether

  if (this.designation === 'reprint') {
    this.designation = 'small_print_job';
  }
};

module.exports = OrderNote;